// import { Avatar } from "@mui/material";
// import profile from "../../assets/image/Player.jpg";
import React, { useState } from "react";
import Google from "../../assets/image/Google.svg";
import home from "../../assets/image/hone.png";
import Phone from "../../assets/image/phone.svg";
// import Player from "../../assets/image/Player.jpg";
import Linkedin from "../../assets/image/Linkedin.svg";
import Testsheet from "../../assets/image/Testsheet.svg";
// import calender from "../../assets/image/calender.png";
// import share from "../../assets/image/share.png";
import question from "../../assets/image/questionmark.png";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import casebox from "../../assets/image/case.png";
import moment from "moment";
import AccountCircle from "@mui/icons-material/AccountCircle";
// import { statusOption } from "../../components/JobInputData";

const ViewApplicantsSidebar = ({ data, isLoadingID }) => {
  // const [inputs, setInputs] = useState({
  //   option: "",
  // });

  // const handleOnChange = (input: any, value: any) => {
  //   setInputs((prevState: any) => ({
  //     ...prevState,
  //     [input]: value,
  //   }));
  // };

  return (
    <div id='Sidenavbar'>
      <div id='SideBar__container'>
        <div className='viewsidebarmain'>
          <div className='viewsidebartop'>
            <div>APPLICANT</div>
            <div>
              <AccountCircle />
            </div>
          </div>
          <div className='viewsidebarcontainer'>
            <div className='viewsidebarspan'>
              {isLoadingID ? (
                <p className=' placeholder-glow'>
                  <span
                    className='placeholder '
                    style={{ width: "9rem" }}
                  ></span>
                </p>
              ) : (
                data?.title +
                " " +
                data?.firstName +
                " " +
                data?.middleName +
                " " +
                data?.LastName
              )}
            </div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={Google} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Email</div>
                  <div className='viewsidebaremail'>
                    {isLoadingID ? (
                      <p className=' placeholder-glow'>
                        <span
                          className='placeholder   '
                          style={{ width: "4rem" }}
                        ></span>
                      </p>
                    ) : !data?.email ? (
                      "N/A"
                    ) : (
                      data?.email
                    )}
                  </div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={Phone} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Phone</div>
                  <div className='viewsidebaremail'>
                    {" "}
                    {isLoadingID ? (
                      <p className=' placeholder-glow  '>
                        <span
                          className='placeholder  '
                          style={{ width: "7rem" }}
                        ></span>
                      </p>
                    ) : !data?.phoneNumber ? (
                      "N/A"
                    ) : (
                      data?.phoneNumber
                    )}
                  </div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={Linkedin} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>LinkedIn Ur</div>
                  <div className='viewsidebaremail'>
                    <a href={`http://${data?.linkedInUrl}`}>
                      {isLoadingID ? (
                        <p className=' placeholder-glow  '>
                          <span
                            className='placeholder  '
                            style={{ width: "10rem" }}
                          ></span>
                        </p>
                      ) : !data?.linkedInUrl ? (
                        "N/A"
                      ) : (
                        data?.linkedInUrl
                      )}{" "}
                    </a>
                  </div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>

            <div className='viewsidebarspan'>
              {isLoadingID ? (
                <p className=' placeholder-glow'>
                  <span
                    className='placeholder '
                    style={{ width: "9rem" }}
                  ></span>
                </p>
              ) : (
                data?.title +
                " " +
                data?.firstName +
                " " +
                data?.middleName +
                " " +
                data?.LastName
              )}
            </div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={Testsheet} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Test Score </div>
                  <div className='viewsidebaremail'>Interview Score </div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>
            <div id='questionmark'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  {"  "}
                  <img src={question} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Status</div>
                </div>
              </div>
              <div className='questionsub'>
                {!data?.applicationStatus ? "n/a" : data?.applicationStatus}
              </div>
            </div>
            <div className='Application'>
              Date of Application{" "}
              <span className='Application-time'>
                {" "}
                {isLoadingID ? (
                  <p className=' placeholder-glow'>
                    <span
                      className='placeholder '
                      style={{ width: "3rem" }}
                    ></span>
                  </p>
                ) : !data?.createdAt ? (
                  "n/a"
                ) : (
                  moment(data?.createdAt).format("MMM Do YY")
                )}
              </span>
            </div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={home} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Current Job Applied</div>
                  <div className='viewsidebaremail'>
                   {data?.Job?.jobRole}
                  </div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={casebox} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Source Type</div>
                  <div className='viewsidebaremail'>External Recruiter</div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>
            <div className='Application'>Recruiter Tagged</div>
            <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <AccountCircle />
                </div>
                <div>
                  <div className='viewsidebartext'>
                    {data?.ApplicationStatusLog[0]?.Recruiter?.firstName}{" "}
                    {data?.ApplicationStatusLog[0]?.Recruiter?.LastName}
                  </div>
                  <div className='viewsidebaremail'>
                    {!data?.ApplicationStatusLog?.[0]?.Recruiter?.role
                      ? "n/a"
                      : data?.ApplicationStatusLog[0]?.Recruiter?.role}
                  </div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div>
            {/* <div className='Application-Offer'>Date of Offer</div> */}
            {/* <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={calender} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Date of Joining</div>
                  <div className='viewsidebaremail'>22-3-2022</div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div> */}
            {/* <div className='viewsidebarcontent'>
              <div className='viewsidebarcontentinner'>
                <div className='viewsidebaricon'>
                  <img src={share} alt='Google' className='Google' />
                </div>
                <div>
                  <div className='viewsidebartext'>Shared with</div>
                  <div className='viewsidebaremail'>Miss Ojo</div>
                </div>
              </div>
              <div>
                <ArrowForwardIosIcon className='viewsidebarelefticon' />
              </div>
            </div> */}
            {/* <select className="round"
							value={inputs.option}
							onChange={(e) => handleOnChange("option", e.target.value)}>
							<option>Select Status</option>
							{statusOption.map((item: any, i: any) => (
								<option key={i} value={item}>
									{item}
								</option>
							))}
						</select> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewApplicantsSidebar;
